import { theme } from '@/styles/theme';

export const styles = {
  bannerView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 1,
    },
  },
  container: {
    backgroundColor: theme.palette.focus.main,
    borderRadius: 4,
    width: '100%',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'start',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '48px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: 2,
      paddingRight: 2,
      marginTop: 2,
    },
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '32px',
    paddingBottom: '32px',
    justifyContent: 'center',
  },
  bottomContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginTop: 3,
  },
  title: {
    fontSize: 24,
    color: 'white',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      paddingBottom: 1,
    },
  },
  storeBox: {
    display: 'flex',
    border: '1px solid white',
    color: 'white',
    borderRadius: 2,
    width: 200,
    height: 60,
    gap: 2,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 3,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 45,
      marginTop: 0,
      marginLeft: 1,
      border: '0.7px solid white',
    },
  },
  description: {
    fontSize: 18,
    color: 'white',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  appleStyle: {
    color: 'white',
    fontSize: 60,
    paddingTop: 1,
    paddingBottom: 1,
    marginRight: -1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 40,
    },
  },
  playStoreStyle: {
    width: 34,
    height: 34,
    marginLeft: 1.5,
    [theme.breakpoints.down('sm')]: {
      width: 20,
    },
  },
  iconTexts: { flexGrow: 1 },
  iconTitle: {
    fontSize: '1.2rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  iconDescription: {
    fontSize: '2rem',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  qrCodeContainer: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '27px',
      paddingRight: '78px',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 150,
      flexGrow: 1,
    },
  },
  qrCodeCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(to right bottom, ${theme.palette.focus.main}, ${theme.palette.focus.dark})`,
    height: '100%',
    padding: 2,
    width: 200,
    boxShadow: '0 0px 8px rgba(0, 0, 0, 0.2)',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    [theme.breakpoints.down('sm')]: {
      padding: 1,
    },
  },
  qrCodeTitle: {
    color: 'white',
    fontSize: 13,
    fontWeight: 600,
    paddingBottom: 2,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  qrCode: {
    height: 150,
    width: 150,
    backgroundColor: 'white',
    marginBottom: 2,
    borderRadius: 1,
    [theme.breakpoints.down('sm')]: {
      height: 130,
      width: 130,
      marginBottom: 1,
    },
  },
  scheduleButton: {
    width: 200,
    marginTop: -2,
    marginRight: -2,
  },
};
